import {SET_DEFAULT_VALUE, SET_SNILS} from "../actions/types";

const defaultState = {
    snils: ""
}
const updateSnils = (state, action) => {
    if (!state) {
        return defaultState;
    }
    switch (action.type) {
        case SET_SNILS:
            return {
                snils: action.payload
            }
        case SET_DEFAULT_VALUE:
            return {
                ...defaultState
            }
        default :
            return {
                ...state.snils
            }
    }
}

export default updateSnils;